import {
  Bell,
  Building2,
  Calendar,
  ClipboardList,
  CreditCard,
  LayoutDashboard,
  Link2,
  Moon,
  Scale,
  ShieldCheck,
  Smartphone,
  Sun,
  Users,
  type LucideIcon,
} from 'lucide-react';

export type NavIcon = LucideIcon;

export const IconDashboard = LayoutDashboard;
export const IconLink = Link2;
export const IconUsers = Users;
export const IconBuilding = Building2;
export const IconCalendar = Calendar;
export const IconScale = Scale;
export const IconBell = Bell;
export const IconClipboardList = ClipboardList;
export const IconShield = ShieldCheck;
export const IconCard = CreditCard;
export const IconSun = Sun;
export const IconMoon = Moon;
export const IconPhone = Smartphone;
